import { __extends } from "tslib";
import { WaveAudio, WaveAudioData, WaveAudioParser } from '@awayjs/core';
var FlashWaveAudioParser = /** @class */ (function (_super) {
    __extends(FlashWaveAudioParser, _super);
    function FlashWaveAudioParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlashWaveAudioParser.prototype.proceedParsing = function () {
        var data = this.data;
        var define = data.definition;
        var meta = {
            sampleRate: define.sampleRate,
            samplesCount: define.samplesCount,
            startOffset: define.packaged.seek,
        };
        //@ts-ignore
        this._content = new WaveAudio(new WaveAudioData(define.packaged.data.buffer, meta));
        this.finalizeAsset(this._content, this.fileName);
        this.finishParsing();
    };
    return FlashWaveAudioParser;
}(WaveAudioParser));
export { FlashWaveAudioParser };
